import useSearchParamsAsObject from '@/hooks/useSearchParamsAsObject'
import lang from '@/lang'

import Approve from '@/modules/account/components/approve/approve'
import accountConfig from '@/modules/account/config'
import accountConfigMeinBuero from '@/modules/account/config.meinbuero'

import { isMeinBuero } from '@/utils/build-env'
import { user } from 'ampersand-app'

import React, { useEffect } from 'react'
import { Route, useNavigate, useParams } from 'react-router'
import Loader from '../base/components/loader/loader'
import { toast } from '../base/components/toast/toastConfig'
import request from '../base/util/request'
import MagicLogin from './components/MagicToken'

import { ROUTES } from './constants'

import config from '@/config'
import RegistrationRedirect from './components/Registration/registration-redirect'
const AcceptInvitation = React.lazy(() => import('./components/accept-invitation'))
const ForgotPassword = React.lazy(() => import('./components/forgot-password'))
const ResetPassword = React.lazy(() => import('./components/reset-password'))
const Registration = React.lazy(() => import('./components/Registration'))
const FinalizeToken = React.lazy(() => import('./components/finalize-token'))
const Login = React.lazy(() => import('./components/login'))
const UndoTenantDeletion = React.lazy(() => import('./components/undo-tenant-deletion'))

const isMB = isMeinBuero()

const loginComponent = () => {
  if (isMB) {
    window.location.replace(accountConfigMeinBuero.login)
    return <Loader />
  } else {
    return <Login />
  }
}

const accountRoutes = (
  <>
    <Route path="account/approve/:token" Component={Approve} />
    <Route path="account/approved" Component={Approve} />
    <Route path="account/approve_resend/:email" Component={Approve} />

    <Route path="login" Component={loginComponent} />
    <Route path="account/login" Component={loginComponent} />
    <Route
      path="account/register"
      Component={() => {
        if (isMB) {
          window.location.replace(accountConfigMeinBuero.registration)
          return <Loader />
        }
        if (ENV.build === 'production') {
          return <RegistrationRedirect targetUrl={config.marketingRegistrationPage} />
        }
        return <Registration />
      }}
    />
    <Route path="account/forgot_password" Component={ForgotPassword} />
    <Route path="account/reset_password/:token" Component={ResetPassword} />
    <Route path="account/finalize/:token" Component={FinalizeToken} />
    <Route
      path="account/magic-login/:token"
      Component={() => {
        const { token } = useParams()
        return <MagicLogin token={token} />
      }}
    />

    <Route
      path="account/accept_invitation/:token"
      Component={() => {
        const { token } = useParams()
        if (isMB) {
          const queryObject = useSearchParamsAsObject()

          window.location = accountConfigMeinBuero.invitation({ invitationToken: token, ...queryObject })
          return <Loader />
        }

        return <AcceptInvitation token={token} />
      }}
    />
    <Route path="account/approvechangeemail/:changeEmailToken" Component={Approve} />

    <Route
      path="account/delete/:token"
      Component={() => {
        const { token } = useParams()
        const navigate = useNavigate()

        const handleDeleteSuccess = () => {
          user.logout(true)
          toast.showToast({ message: lang.accountDeleteSuccessMessage })
        }
        const handleDeleteError = () => {
          toast.showToast({ message: lang.accountDeleteErrorMessage, type: 'error' })
        }

        useEffect(() => {
          request(accountConfig.endpoints.deleteUser, { method: 'DELETE', data: { token } })
            .then(handleDeleteSuccess)
            .catch(handleDeleteError)
            .done(() => navigate(ROUTES.login))
        }, [])

        return <Loader />
      }}
    />

    <Route path="account/undo-tenant-deletion/:token" Component={UndoTenantDeletion} />
  </>
)

export default accountRoutes
